import React from 'react'
import {Typography, Box, useTheme} from '@mui/material'
import {EnhancementReportStat} from '../../../models/enhancement/enhancement-report-stats'
import {useEnhancementOverview} from './useEnhancementOverview'
import EnhancementTile from './EnhancementTile'

interface EnhancementOverviewTilesProps {
  reportData: EnhancementReportStat[];
  dataTestId?: string;
  selectedRequestTypes?: string[] | null;
  onTileClick?: (requestType: string) => void;
}

function NoDataMessage({dataTestId}: { dataTestId: string }) {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 4,
        mb: 3,
        border: `1px dashed ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper
      }}
      data-testid={`${dataTestId}-NoData`}
    >
      <Typography variant="h6" color="text.secondary">
        No enhancement data available for the selected filters
      </Typography>
    </Box>
  )
}

function EnhancementOverviewTiles({
                                    reportData,
                                    dataTestId = 'EnhancementOverview',
                                    selectedRequestTypes,
                                    onTileClick
                                  }: EnhancementOverviewTilesProps) {
  const {overviewTiles} = useEnhancementOverview(reportData)
  const theme = useTheme()

  if (!reportData || reportData.length === 0) {
    return <NoDataMessage dataTestId={dataTestId} />
  }

  return (
    <Box
      mb="16px"
      display="flex"
      padding="6px 4px"
      sx={{
        overflowX: 'auto',
      }}
      data-testid={dataTestId}
    >
      {overviewTiles.map((tile) => (
        <EnhancementTile
          key={tile.name}
          tile={tile}
          dataTestId={`${dataTestId}-Tile`}
          isSelected={tile.name === 'Total'
            ? !selectedRequestTypes || selectedRequestTypes.length === 0
            : selectedRequestTypes?.includes(tile.name) || false}
          onClick={onTileClick}
        />
      ))}
    </Box>
  )
}

export default EnhancementOverviewTiles